import React from "react";
import { useSelector } from "react-redux";
import {
  selectPriceBreakdown,
  selectSoldToShipTo,
} from "../../../redux/selectors";

const formatCurrency = (amount) => {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }).format(amount);
};

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (date.getFullYear() < 2000) return "";
  const options = { year: "numeric", month: "long", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
};

const PrintPriceBreakdown = () => {
  const priceBreakdownDetails = useSelector(selectPriceBreakdown);
  const shipToSoldToDetails = useSelector(selectSoldToShipTo);

  const renderDetails = (details) => {
    if (!details || !Array.isArray(details) || details.length === 0) {
      return <p>No price breakdown details available</p>;
    }

    return details.map((detail, index) => (
      <div className="section" key={index}>
        <h2 className="text-center">
          <strong>Invoice Price Breakdown Summary</strong>
        </h2>
        <table className="additional-details">
          <tbody>
            <tr>
              <td>
                <strong>Invoice Price: </strong>
                {formatCurrency(shipToSoldToDetails[0].InvoicePrice)}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Multiplier: </strong>
                {shipToSoldToDetails[0].GrossMarginPercent}%
              </td>
            </tr>
            <tr>
              <td>
                <strong>Corrected Invoice Price: </strong>

                {formatCurrency(shipToSoldToDetails[0].InvoicePriceCorrected)}
              </td>
            </tr>
            <tr>
              <td>
                <strong>Invoice Price Change Order Date: </strong>
{formatDate(shipToSoldToDetails[0].InvoicePriceCODate)}</td>

              <td>
                <strong>Payment Terms: </strong>
{shipToSoldToDetails[0].PaymentTerms}</td>
            </tr>
            <tr>
              <td>
                <strong>Special Terms Approved By: </strong>
{shipToSoldToDetails[0].SpecialTermsApprovedBy}</td>
            </tr>
          </tbody>
        </table>
        <br />
        <h2 className="text-center"><strong>Price Breakdown</strong></h2>
        <table className="subtables">
          <tr>
            <td></td>
            <td>
              <strong>Amount</strong>
            </td>
            <td>
              <strong>Pay To</strong>
            </td>
            <td>
              <strong>Provider Quote</strong>
            </td>
          </tr>
          <tr>
            <td>
              <strong>Sell Price</strong>
            </td>
            <td className="currency">
              {formatCurrency(detail.SellPriceAmount)}
            </td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Freight</strong>
            </td>
            <td className="currency">{formatCurrency(detail.FreightAmount)}</td>
            <td>{detail.FreightPayTo}</td>
            <td>{detail.FreightProviderQuote}</td>
          </tr>
          <tr>
            <td>
              <strong>Rebate</strong>
            </td>
            <td className="currency">{formatCurrency(detail.RebateAmount)}</td>
            <td>{detail.RebatePayTo}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Commission 1</strong>
            </td>
            <td className="currency">
              {formatCurrency(detail.Commission1Amount)}
            </td>
            <td>{detail.Commission1PayTo}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Commission 2</strong>
            </td>
            <td className="currency">
              {formatCurrency(detail.Commission2Amount)}
            </td>
            <td>{detail.Commission2PayTo}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Commission 3</strong>
            </td>
            <td className="currency">
              {formatCurrency(detail.Commission3Amount)}
            </td>
            <td>{detail.Commission3PayTo}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Taxes</strong>
            </td>
            <td className="currency">{formatCurrency(detail.Taxes)}</td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Setup Cost</strong>
            </td>
            <td className="currency">{formatCurrency(detail.SetupAmount)}</td>
            <td>{detail.SetupPayTo}</td>
            <td>{detail.StartProviderQuote}</td>
          </tr>
          <tr>
            <td>
              <strong>Startup Cost</strong>
            </td>
            <td className="currency">{formatCurrency(detail.StartAmount)}</td>
            <td>{detail.StartPayTo}</td>
            <td>{detail.StartPayTo}</td>
          </tr>
          <tr>
            <td>
              <strong>Crane</strong>
            </td>
            <td className="currency">{formatCurrency(detail.CraneAmount)}</td>
            <td>{detail.CranePayTo}</td>
            <td>{detail.CraneProviderQuote}</td>
          </tr>
          <tr>
            <td>
              <strong>Inspection Service</strong>
            </td>
            <td className="currency">
              {formatCurrency(detail.InspectionAmount)}
            </td>
            <td>{detail.InspectionPayTo}</td>
            <td>{detail.InspectionProviderQuote}</td>
          </tr>
          <tr>
            <td>
              <strong>Warranty</strong>
            </td>
            <td>
              {detail.WarrantyAmount}
            </td>
            <td>{detail.WarrantyAdditionalCost}</td>
            <td></td>
          </tr>
          <tr>
            <td>
              <strong>Other</strong>
            </td>
            <td className="currency">{formatCurrency(detail.OtherAmount)}</td>
            <td>{detail.OtherPayTo}</td>
            <td>{detail.OtherProviderQuote}</td>
          </tr>
          <tr>
            <td>
              <strong>Net Revenue</strong>
            </td>
            <td className="currency">{formatCurrency(detail.NetRevenue)}</td>
            <td></td>
            <td></td>
          </tr>
        </table>
      </div>
    ));
  };

  return (
    <div>
      {priceBreakdownDetails ? (
        renderDetails(priceBreakdownDetails)
      ) : (
        <p>Loading...</p>
      )}
    </div>
  );
};

export default PrintPriceBreakdown;
